import { createAction, props } from '@ngrx/store';
import { Load } from '../_models';

// Action types
export const loadLoads = createAction('[Load] Load Loads');
export const loadLoadsSuccess = createAction(
  '[Load] Load Loads Success',
  props<{ loads: Load[] }>()
);
export const loadLoadsFailure = createAction('[Load] Load Loads Failure', props<{ error: any }>());

export const addLoad = createAction('[Load] Add Load', props<{ load: Load }>());
export const addLoadSuccess = createAction('[Load] Add Load Success', props<{ load: Load }>());
export const addLoadFailure = createAction('[Load] Add Load Failure', props<{ error: any }>());

export const updateLoad = createAction('[Load] Update Load', props<{ load: Load }>());
export const updateLoadSuccess = createAction(
  '[Load] Update Load Success',
  props<{ load: Load }>()
);
export const updateLoadFailure = createAction(
  '[Load] Update Load Failure',
  props<{ error: any }>()
);

export const deleteLoad = createAction('[Load] Delete Load', props<{ id: number }>());
export const deleteLoadSuccess = createAction(
  '[Load] Delete Load Success',
  props<{ id: number }>()
);
export const deleteLoadFailure = createAction(
  '[Load] Delete Load Failure',
  props<{ error: any }>()
);
